import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useLocation } from 'react-router-dom'
import { tidTrainKindClass } from '../../utils/ClassHelper'

const TRAIN_DIRECTION_CLASS = {
  'up': 'is_up',
  'down': 'is_down'
}

const MultipleTrain = ({ trains, openTrainSelectModal, intl }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleTrainClick = () => {
    openTrainSelectModal(trains)
    navigate(`${location.pathname}/select`)
  }

  return (
    <a onClick={handleTrainClick} className={`d-TrainPosition-train ${tidTrainKindClass(trains[0])}Multiple ${TRAIN_DIRECTION_CLASS[trains[0].direction]}`}>
      <div className="d-TrainPosition-trainBody">
        <div className="d-TrainPosition-trainMark"></div>
      </div>
    </a>
  )
}

MultipleTrain.propTypes = {
  trains: PropTypes.array.isRequired,
  openTrainSelectModal: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
}

export default MultipleTrain
